export let AgreementChangeType;

(function (AgreementChangeType) {
  AgreementChangeType["CoverCreditCardFees"] = "creditCardFeesCoverChangeData";
  AgreementChangeType["CoverDirectDebitFees"] = "directDebitFeesCoverChangeData";
  AgreementChangeType["NetTerms"] = "netTermsChangeData";
  AgreementChangeType["AmendmentsApprovalMethod"] = "amendmentsApprovalMethodChangeData";
  AgreementChangeType["BillingDayOfWeek"] = "relationshipBillingDayOfWeekChangeData";
  AgreementChangeType["LegalTerms"] = "legalTermsChangeData";
  AgreementChangeType["Services"] = "serviceChangeData";
  AgreementChangeType["ManualPayments"] = "manualPaymentsChangeData";
  AgreementChangeType["Title"] = "titleChangeData";
})(AgreementChangeType || (AgreementChangeType = {}));